<template>
  <div
    style="max-width: 500px; margin: 0 auto;"
  >
    <v-card
      v-if="$hasRole('ADMIN')"
    >
      <div
        class="cdseo-grey-bg d-flex"
      >
        <v-card-title
          class="flex-grow-1"
        >Re-create Shopify Subscription</v-card-title>
        <div
          v-if="$hasRole('SUPERUSER')"
          class="pa-3"
        >
          <v-btn
            icon
            @click="$store.commit('setSuperuserOverride', true)"
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </div>
      </div>
      <v-card-text>
        <v-alert type="error" prominent dense>
          We need you to create a new recurring subscription in Shopify in order to use CDSEO. Click the button below to begin creating a new subscription.
        </v-alert>
      </v-card-text>
      <v-card-actions
        class="px-4 pb-4"
      >
        <v-spacer />
        <v-btn
          large
          color="primary"
          href="/api/account/select_plan?plan_id=CURRENT"
          @click="loading = true"
          :loading="loading"
        >Continue</v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      v-else
    >
      <v-card-title>Account Is Locked</v-card-title>
      <v-card-text>
        This account is locked and is waiting on an account administrator to take action.
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false
    }
  },
  methods: {
  }
}
</script>
